import { render, staticRenderFns } from "./competency-info-panel.vue?vue&type=template&id=4e1bc2e5&scoped=true&"
import script from "./competency-info-panel.ts?vue&type=script&lang=ts&"
export * from "./competency-info-panel.ts?vue&type=script&lang=ts&"
import style0 from "./competency-info-panel.scss?vue&type=style&index=0&id=4e1bc2e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1bc2e5",
  null
  
)

export default component.exports